import { render, staticRenderFns } from "./DashboardCell.vue?vue&type=template&id=14c1cab0&"
import script from "./DashboardCell.vue?vue&type=script&lang=js&"
export * from "./DashboardCell.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCell.vue?vue&type=style&index=0&id=14c1cab0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports